"use client"

import { Label } from "../Label/Label.component"
import { Translation } from "../Translation/Translation.component"

type RequiresSubscriptionLabelProps = {
  readonly className?: string
  readonly size?: "xs" | "sm"
}

export function RequiresSubscriptionLabel({
  className,
  size = "sm",
}: RequiresSubscriptionLabelProps) {
  return (
    <Label className={className} size={size}>
      <Translation
        model={{
          da: "Abonnement",
          de: "Abonnement",
          en: "Subscription",
          no: "Abonnement",
          sv: "Prenumeration",
        }}
      />
    </Label>
  )
}
